export const NOTIFICATION_API_EX_RAISE = 'NOTIFICATION_API_RAISE';
export const NOTIFICATION_API_EX_CANCEL = 'NOTIFICATION_API_CANCEL';
export const NOTIFICATION_EX_RAISE = 'NOTIFICATION_EX_RAISE';

export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';
export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';
